import React from 'react';

// import Articles from 'components/plataforma/articles';
// import Technology from 'components/plataforma/technology';
import Head from 'next/head';

import { Footer } from 'modules/common/Footer';
import { FooterCollection } from 'modules/common/Footer/Footer.types';
import { Header } from 'modules/common/Header';
import { HeaderCollection } from 'modules/common/Header/Header.types';
import { About } from 'modules/plataforma/About';
import { AboutCollection } from 'modules/plataforma/About/About.types';
import { Articles } from 'modules/plataforma/Articles';
import { ArticlesCollection } from 'modules/plataforma/Articles/Articles.types';
import { Growth } from 'modules/plataforma/Growth';
import { GrowthCollection } from 'modules/plataforma/Growth/Growth.types';
import { Hero } from 'modules/plataforma/Hero';
import { HeroPlatformaCollection } from 'modules/plataforma/Hero/Hero.types';
import { Plataform } from 'modules/plataforma/Plataform';
import { PlataformCollection } from 'modules/plataforma/Plataform/Plataform.types';

import contentfulData from '../services/contentful';
import { queryPlataform } from '../services/contentful/querys';

type HomeProps = {
  menuPrincipal: HeaderCollection;
  menuRodape: FooterCollection;
  about: AboutCollection;
  heroPlataforma: HeroPlatformaCollection;
  growth: GrowthCollection;
  plataform: PlataformCollection;
  technology: PlataformCollection;
  articles: ArticlesCollection;
};

const Plataforma = ({
  about,
  articles,
  growth,
  heroPlataforma,
  menuPrincipal,
  menuRodape,
  plataform,
  technology,
}: HomeProps) => {
  return (
    <div>
      <Head>
        <title>Plataforma | Olist Vnda - Tecnologia em E-commerce </title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header menus={menuPrincipal.menus} />
      <main>
        <Hero
          title={heroPlataforma.title}
          description={heroPlataforma.description}
          image={heroPlataforma.image}
        />
        <Growth items={growth.items} title={growth.title} subtitle={growth.subtitle} />
        <About items={about.items} title={about.title} subtitle={about.subtitle} />
        <Plataform
          image={plataform.image}
          list={plataform.list}
          text={plataform.text}
          title={plataform.title}
        />
        <Plataform
          image={technology.image}
          list={technology.list}
          text={technology.text}
          title={technology.title}
        />
        <Articles items={articles.items} />
      </main>

      <Footer menus={menuRodape.menus} />
    </div>
  );
};

export default Plataforma;

export async function getServerSideProps() {
  const data = await contentfulData(queryPlataform());

  return {
    props: data,
  };
}
